// ✅ LinearProgress.js (New Component)
import React from "react";
import "../styles/ClubPage.css"; // Reuse existing styles

const LinearProgress = ({ percentage }) => {
    return (
        <div className="progress-container">
            <p>{Math.round(percentage)}%</p>
            <div className="progress-bar">
                <div
                    className="progress-fill"
                    style={{ width: `${percentage}%` }}
                ></div>
            </div>
        </div>
    );
};

export default LinearProgress;